import { useEffect, useState } from 'react';
export var useAccessToken = function useAccessToken() {
  var _useState = useState(),
      accessToken = _useState[0],
      setAccessToken = _useState[1];

  useEffect(function () {
    var authToken = localStorage.getItem('access_token');
    if (authToken) setAccessToken(authToken);
  });
  return [accessToken];
};